import axios from 'axios';

const editStaffInfo = (data) => {
  return axios
    .put(`${process.env.REACT_APP_API_URL}/api/staff/${data.mobileNumber}`, data)
    .then(res => res)
    .catch(err => err);
};

export default editStaffInfo;
